import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import sanityClient from "../../client";
import BlockContent from "@sanity/block-content-to-react";
import Loading from "../components/Loading";
import NavEn from "./NavEn";
import FooterEn from "./FooterEn";

function Home() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const query = `
    *[_type=="home"]{
      "about": aboutUs.en,
      "headerDesc": headerDescription.en,
      "headerImage": headerImage.asset->url,
      "headerTitle": headerTitle.en,
      "note": note.en,
      "project": project->{
        "slug": Slug.current,
        "address": address.en,
        "name": name.en,
        "image": images[0].asset->url
      },
      "properties": properties[]->{
        "slug": Slug.current,
        "name": name.en,
        "image": images[0].asset->url,
        availability
      },
      "serviceImage": serviceImage.asset->url,
      "services": services.en,
      "numbers": Numbers[]{
        number,
        "numberDesc": numberDesc.en
      }
    }
  `;

    sanityClient
      .fetch(query)
      .then((data) => {
        setData(data[0]);
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        setLoading(false);
        console.log(err);
      });

    document.title = "Home - CompanyName";
    document.querySelector("html").lang = "en";
    
  }, []);

  if (loading) {
    return <Loading />;
  }
  if(error) {
    return <h1>Sorry There is a problem, Try agin.</h1>
  }
  const {
    about,
    headerDesc,
    headerImage,
    headerTitle,
    note,
    project,
    properties,
    serviceImage,
    services,
    numbers,
  } = data;
  return (
    <>
      <NavEn url="/ar" />
      <div>
        <header>
          <div className="left">
            <div className="center">
              <h1>
                {/* Delivering high quality <span>Appartments</span>, with a nice
              price */}
                {headerTitle}
              </h1>
              <p>{headerDesc}</p>
              <Link to="/contact">Contact us</Link>
            </div>
          </div>
          <div className="right">
            <img src={headerImage} alt="gt-home img" />
          </div>
        </header>
        <div className="about">
          <h2>About us</h2>
          <p>{about}</p>
          <p className="note">Note : {note} </p>
        </div>
        <div className="services">
          <div className="left">
            <img src={serviceImage} alt="gt-home img" />
          </div>
          <div className="right">
            <h2>Our main services</h2>
            <BlockContent blocks={services} />
          </div>
        </div>
        <div className="project">
          <div className="left">
            <h3>{project.address}</h3>
            <h2>{project.name}</h2>
            <Link to={"/projects/" + project.slug}>View Project</Link>
          </div>
          <div className="right">
            <img src={project.image} alt="gt-home img" />
          </div>
        </div>

        <div className="apartments">
          {/* <h2>Properties</h2> */}
          <div className="content">
            {properties.map(({ slug, name, image }) => {
              return (
                <div className="apartment" key={slug}>
                  <Link to={"/properties/" + slug}>
                    <img src={image} alt="gt home img" />
                    <h4>{name}</h4>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>

        <div className="numbers">
          <h2>Some Numbers</h2>
          <div className="num-container">
            {numbers.map(({ number, numberDesc }, index) => {
              return (
                <div className="num" key={index}>
                  <span>{number}+</span>
                  <h4>{numberDesc}</h4>
                </div>
              );
            })}
          </div>
        </div>

        <div className="contact" id="contact-sec">
          <h2>Contact us</h2>
          <p>
            We are at the service. We put at your disposal the following numbers
            for reservations and inquiries"
          </p>
          <div className="info-container">
            <div className="con-info">
              <h3>Ahmed El amine</h3>
              <span>0557745847</span>
            </div>
            <div className="con-info">
              <h3>Ahmed El amine</h3>
              <span>0557745847</span>
            </div>
            <div className="con-info">
              <h3>Ahmed El amine</h3>
              <span>0557745847</span>
            </div>
          </div>
        </div>
      </div>
      <FooterEn />
    </>
  );
}

export default Home;
